var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticStyle:{"padding":"10px","border-radius":"5px","background-color":"#555","color":"white"}},[_vm._v("\n        Work Activities (Average Time)\n    ")]),_c('slider',{attrs:{"sliders":_vm.activities}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }